
import { Link } from 'react-router-dom';
import useAuthStatus from '../../hooks/useAuthStatus';

export default function Footer() {
  const isAuthenticated = useAuthStatus();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src="https://public.readdy.ai/ai/img_res/dd477a5b-805d-49f5-aa81-9f7e2ed67552.png" alt="MakkyTrade Logo" className="h-10 w-10 object-contain" />
              <span className="text-2xl font-bold">MakkyTrade</span>
            </div>
            <p className="text-gray-400 leading-relaxed">Your trusted platform for secure cryptocurrency and gift card trading.</p>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-4">Platform</h4>
            <ul className="space-y-3">
              <li><Link to="/market" className="text-gray-400 hover:text-white transition-colors">Market</Link></li>
              <li><Link to="/wallet" className="text-gray-400 hover:text-white transition-colors">Wallet</Link></li>
              <li><Link to="/transactions" className="text-gray-400 hover:text-white transition-colors">Transactions</Link></li>
              {(isAuthenticated && 
                <li><Link to="/kyc" className="text-gray-400 hover:text-white transition-colors">KYC Verification</Link></li>
               )}
              
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-4">Support</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Help Center</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Security</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Cookie Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Compliance</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">© 2024 MakkyTrade. All rights reserved.</p>
          <a href="https://makkytrade.com" className="text-gray-400 hover:text-white text-sm transition-colors">Website Builder</a>
        </div>
      </div>
    </footer>
  );
}
